import { useCallback, useReducer } from "react";
const initialState = {
  data: null,
  isPending: false,
  error: null,
};
const actionTypes = {
  MUTATE_START: "MUTATE_START",
  MUTATE_SUCCESS: "MUTATE_SUCCESS",
  MUTATE_FAILURE: "MUTATE_FAILURE",
};
const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.MUTATE_START:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case actionTypes.MUTATE_SUCCESS:
      return {
        ...state,
        isPending: false,
        data: action.payload,
      };
    case actionTypes.MUTATE_FAILURE:
      return {
        ...state,
        isPending: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
const useMutation = (mutationFunction) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const mutate = useCallback(
    async (data) => {
      dispatch({ type: actionTypes.MUTATE_START });
      try {
        const response = await mutationFunction(data);
        dispatch({ type: actionTypes.MUTATE_SUCCESS, payload: response });
        return response;
      } catch (error) {
        dispatch({ type: actionTypes.MUTATE_FAILURE, payload: error });
        throw error;
      }
    },
    [mutationFunction]
  );
  return { ...state, mutate };
};
export default useMutation;
